var r={backspace:"Backspace",arrowLeft:"ArrowLeft",arrowRight:"ArrowRight"},e="text",t=/\D/g,a="one-time-code";export{e as CLIPBOARD_TEXT_FORMAT,r as KEYBOARD_EVENTS,t as NON_DIGIT_PATTERN,a as ONE_TIME_CODE_AUTOCOMPLETE};
//# sourceMappingURL=otpInput.constants.js.map
